import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
export const DescriptionItem = ({ label, name }) => {
    const { watch } = useFormContext();
    const value = watch(name);
    if (!value)
        return null;
    return (_jsxs("div", Object.assign({ className: 'd-flex flex-column mx-3' }, { children: [_jsx("h5", { children: label }), _jsx("span", Object.assign({ className: 'm-0' }, { children: value }))] })));
};
